// extracted by mini-css-extract-plugin
export default {"checkboxDescription":"AddonsCard_checkboxDescription__aT75k"};